// extracted by mini-css-extract-plugin
export default {"confirm":"SideDeleteModal_confirm__83SAp"};